import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.colors.grey100};
  min-height: calc(100vh - 50px);
`;

export const Wrapper = styled.div`
  padding: 16px;
`;
